import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={`flex items-center gap-2 text-white hover:text-fac-green ${className}`}
      data-testid="language-toggle"
    >
      <Globe className="w-4 h-4" />
      <span className="font-medium">{language === 'en' ? '中文' : 'EN'}</span>
    </Button>
  );
};

export default LanguageToggle;
